import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { useMemo } from 'react'

import { intl } from '@/intl'
import { getRecurrenceLabel } from '@/server-data'
import { ModalHeader } from '@/components/Modal'

import { useTexts } from '../hooks/useTexts'
import { useController } from '../hooks/useController'
import { useFormRecurrence } from '../hooks/useFormRecurrence'
import { EditTrafficProfileModalProps } from '../types'

export function Header(props: EditTrafficProfileModalProps) {
  const texts = useTexts()
  const recurrence = useFormRecurrence(props.trafficProfile.id)

  const { close } = useController()

  const { translate } = intl

  const { type, value } = recurrence

  const recurrenceLabel = useMemo(
    () => getRecurrenceLabel(type, value, translate),
    [type, value, translate],
  )

  return (
    <ModalHeader
      actions={[
        <ActionBarItem
          icon={<Close />}
          testId="close-button"
          key="close"
          onClick={close}
          label=""
        />,
      ]}
      title={texts.header.title(recurrenceLabel)}
    />
  )
}
